import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import ArticleItem from './ArticleItem';
import { getArticles } from '../../actions/article';

const Articles = ({ getArticles, article: { articles, loading } }) => {
  useEffect(() => {
    getArticles();
  }, [getArticles]);
  return loading ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="row justify-content-center">
        <div className="col-11 col-md-9 col-lg-7 mt-4">
          <h1 className="rb">Articles</h1>
          <h5 className="rb pt-2 pb-3">
            <i className="fas fa-book-open"></i> Check out our latest work
          </h5>

          <div className="articles">
            {articles.map((article) => (
              <ArticleItem key={article._id} article={article} />
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

Articles.propTypes = {
  getArticles: PropTypes.func.isRequired,
  article: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  article: state.article
});

export default connect(mapStateToProps, { getArticles })(Articles);
